import { render, staticRenderFns } from "./NewUserRegistration.vue?vue&type=template&id=76ac1a72&scoped=true&"
import script from "./NewUserRegistration.vue?vue&type=script&lang=js&"
export * from "./NewUserRegistration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76ac1a72",
  null
  
)

export default component.exports